import { Box, Typography } from "@mui/material";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";
import { RoutingURLs } from "../../../config/RoutingURLs";
import ThreePIcon from "@mui/icons-material/ThreeP";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone"
import EmailIcon from "@mui/icons-material/Email";


type Props = {
  content: any;
};
const T2ForSupport = (props: Props) => {
  const { content } = props;
  const { support, support_timing } = content;

  const onClickHandler = (path: any) => {
    if (path === RoutingURLs.chatbot) {
      window.open(RoutingURLs.chatbot, "_self");
      setTimeout(() => {
        window.history.replaceState(null, "", location.pathname);
      }, 1000);
    } else {
      return false;
    }
  };

  return (
    <Box
      sx={{
        background: "var(--white) !important",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: { xs: "30px auto", md: "100px auto" },
          width: { xs: "94%", md: "70%" },
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        {support?.map((element: any, index: number) => {
          const { img, path, text, id, timing, support_timing_desc, subText } = element;
          return (
            <Box
              component={"a"}
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", md: "center" },
                alignItems: "center",
                gap: "15px",
                textDecoration: "none",
                padding: "10px",
              }}
              key={id}
              href={
                BrandNameUpdate(path) === RoutingURLs.chatbot
                  ? undefined
                  : BrandNameUpdate(path)
              }
            >
              {/* <Box
                component="img"
                src={img?.data?.attributes?.url}
                alt={img?.data?.attributes?.alternativeText}
               
                onClick={() => onClickHandler(BrandNameUpdate(path))}
              /> */}

              {index == 0 && (
                <ThreePIcon
                  sx={{
                    cursor: "pointer",
                    color: "var(--primary_color)",
                    fontSize: "40px",
                  }}
                  onClick={() => onClickHandler(BrandNameUpdate(path))}
                />
              )}
              {index == 1 && (
                <ContactPhoneIcon
                  sx={{
                    cursor: "pointer",
                    color: "var(--primary_color)",
                    fontSize: "40px",
                  }}
                  onClick={() => onClickHandler(BrandNameUpdate(path))}
                />
              )}
              {index == 2 && (
                <EmailIcon
                  sx={{
                    cursor: "pointer",
                    color: "var(--primary_color)",
                    fontSize: "40px",
                  }}
                  onClick={() => onClickHandler(BrandNameUpdate(path))}
                />
              )}
              <Box>
                <Typography
                  sx={{
                    fontFamily: "var(--font_family_Semibold)",
                    fontSize: "18px",
                    lineHeight: "24px",
                    color: "var(--black)",
                    width: "fit-content",
                    cursor: "pointer",
                  }}
                  onClick={() => onClickHandler(BrandNameUpdate(path))}
                >
                  {BrandNameUpdate(id !== support.length ? text : subText)}
                </Typography>
                {id !== support.length && (
                  <Typography
                    sx={{
                      fontFamily: "var(--font_family_Regular)",
                      fontSize: "12px",
                      lineHeight: "24px",
                      color: "var(--text_color)",
                      width: "fit-content",
                      cursor: "pointer",
                    }}
                    onClick={() => onClickHandler(BrandNameUpdate(path))}
                  >
                    {support_timing_desc}
                  </Typography>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default T2ForSupport;
